import React, { useState, useEffect } from "react";
import styles from "./QuestionBank.module.css";
import Animation from "../Result/Animation/Animation";

const QuestionBank = () => {
  const [branch, setBranch] = useState("");
  const [sem, setSem] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Animation state
  const [showAnimation, setShowAnimation] = useState(true);

  // Auto-hide animation after 2 sec
  useEffect(() => {
    const timer = setTimeout(() => setShowAnimation(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const fetchQuestions = async () => {
    if (!branch || !sem) {
      alert("Please select both Branch and Semester");
      return;
    }

    setLoading(true);
    setError(null);
    setQuestions([]);

    const params = new URLSearchParams({
      key: "rec1723",
      branch: branch.toLowerCase(),
      sem: sem,
    });

    try {
      const resp = await fetch(
        `https://recstudentportal.com/api/v1/getQuestion.php?${params.toString()}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!resp.ok) {
        throw new Error(`HTTP error! status: ${resp.status}`);
      }

      const data = await resp.json();
      setQuestions(data);
    } catch (err) {
      console.error("Error:", err);
      setError("Failed to load data");
    }

    setLoading(false);
  };

  return (
    <>
      {showAnimation && (
        <div className={styles.animationScreen}>
          <Animation />
          <h3>Please Wait...</h3>
        </div>
      )}

      {!showAnimation && (
        <div className={styles.container}>
          <h1 className={styles.heading}>Question Bank</h1>

          <div className={styles.formBox}>
            <select value={branch} onChange={(e) => setBranch(e.target.value)}>
              <option value="">Select Branch</option>
              <option value="cse">CSE</option>
              <option value="ece">ECE</option>
              <option value="ee">EE</option>
              <option value="me">ME</option>
              <option value="ce">CE</option>
            </select>

            <select value={sem} onChange={(e) => setSem(e.target.value)}>
              <option value="">Select Semester</option>
              <option value="1">Semester 1</option>
              <option value="2">Semester 2</option>
              <option value="3">Semester 3</option>
              <option value="4">Semester 4</option>
              <option value="5">Semester 5</option>
              <option value="6">Semester 6</option>
              <option value="7">Semester 7</option>
              <option value="8">Semester 8</option>
            </select>

            <button onClick={fetchQuestions}>Search</button>
          </div>

          {loading && <p className={styles.loading}>Loading...</p>}
          {error && <p className={styles.error}>{error}</p>}

          <div className={styles.resultBox}>
            {questions.length === 0 && !loading && !error && (
              <p className={styles.noData}>No data found</p>
            )}

            {questions.map((item, idx) => {
              const pdfURL = `https://recstudentportal.com/ram/${item.path}`;

              return (
                <div key={idx} className={styles.card}>
                  <h3>{item.sub}</h3>
                  <p>Year: {item.year}</p>

                  <a href={pdfURL} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionBank;
